import React from 'react'

export default function Home() {
    return (
        <div className='container d-flex  flex-column justify-content-center align-content-center'>
            <div className='row'> <img src="https://raw.githubusercontent.com/sonersimsekdev/bootstrap-static/main/img/main/pets_large.jpeg" className='img-fluid'alt="animals" /></div>
            <div className='row'>
            <img src='https://raw.githubusercontent.com/sonersimsekdev/bootstrap-static/main/img/main/pets-4.jpg' className='img-fluid' alt="animal" /></div>
        </div>
    )
}

